export enum SmsDeliveryStatus {
	SENT = 'sent',
	PENDING = 'pending',
	FAILED = 'failed',
	FAILED_UNKNOWN = 'failed_unknown',
	NO_PHONE = 'no_phone',
}
